import {
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	ListItemText,
	MenuItem,
	TextField,
	FormControlLabel
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Autocomplete from '@material-ui/lab/Autocomplete'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { DeletableChip } from '../../components/Misc/DeletableChip'
import {
	PLAY_STYLES_ARRAY,
	PLAYGROUP_TYPE_AGES as PLAYGROUP_TYPE_AGES_ARRAY,
	PLAYGROUP_TYPE_BEST_FIT_SIZES_ARRAY,
	PLAYGROUP_TYPE_SIZES_ARRAY,
} from '../../utils'

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			maxWidth: '920px',
			minWidth: '700px'
		}
	},
	formWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		margin: '24px 0px',
		'& .MuiTextField-root': {
			minWidth: '274px !important'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '274px !important'
		}
	},
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px'
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 2
	},
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '7px !important'
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	datePicker: {
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		},
		'&:nth-child(1)': {
			marginRight: '16px !important'
		}
	}
}))

const sizes = PLAYGROUP_TYPE_SIZES_ARRAY
const best_fit_sizes = PLAYGROUP_TYPE_BEST_FIT_SIZES_ARRAY
const styles = PLAY_STYLES_ARRAY
const ages = PLAYGROUP_TYPE_AGES_ARRAY

const PlaygroupTypeDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()

	const { isShown, setIsShown, playgroupType, updateGroup, save, setDelete, playgroup_types } = props

	const isDisabled = () => {
		if (
			!playgroupType ||
			!playgroupType.name ||
			!playgroupType.size ||
			!playgroupType.play_style ||
			!playgroupType.best_fit_sizes ||
			!playgroupType.age_category ||
			playgroupType.name.length > 20
		)
			return true
		return false
	}

	const disableCompatToggle = () => {
		if (!playgroup_types || !playgroupType) return false
		return !!playgroup_types.find(g => g.is_compatibility_group && g._id !== playgroupType._id)
	}

	return (
		<Dialog
			open={isShown}
			width="md"
			onClose={() => setIsShown()}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}>
			<DialogTitle>{playgroupType?._id ? 'Edit Playgroup Type' : 'Add New Playgroup Type'}</DialogTitle>
			<DialogContent>
				<div className={classes.formWrapper}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							label="Name"
							value={playgroupType.name}
							error={playgroupType.name?.length > 20}
							helperText={`${playgroupType.name?.length} / 20`}
							required
							style={{ width: '48%', marginBottom: 16 }}
							onChange={(e) => updateGroup('name', e.target.value)}
							variant="filled"
						/>
						<TextField
							select
							label="Size Category"
							value={playgroupType.size}
							style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
							required
							onChange={(e) => updateGroup('size', e.target.value)}
							variant="filled">
							{sizes.map((s) => (
								<MenuItem value={s} style={{ textTransform: 'capitalize' }}>
									{s}
								</MenuItem>
							))}
						</TextField>
					</div>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							select
							label="Play Style"
							value={playgroupType.play_style}
							required
							onChange={(e) => updateGroup('play_style', e.target.value)}
							style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
							variant="filled">
							{styles.map((s) => (
								<MenuItem value={s} style={{ textTransform: 'capitalize' }}>
									{s}
								</MenuItem>
							))}
						</TextField>

						<Autocomplete
							multiple
							disableCloseOnSelect
							size="small"
							id="breed"
							style={{ width: '48%' }}
							className={classes.autoComplete}
							options={best_fit_sizes}
							multiple
							required
							value={playgroupType?.best_fit_sizes || []}
							onChange={(e, v) => {
								if (v?.includes('all')) {
									if (!playgroupType.best_fit_sizes.includes('all')) {
										v = ['all']
									} else {
										v = v.filter(size => size !== 'all')
									}
								}
								updateGroup('best_fit_sizes', v)
							}}
							onClose={(e) => {
								e.target.value = ''
							}}
							renderTags={(selected) =>
								selected.map((value) => (
									<DeletableChip
										key={value}
										label={value}
										style={{ textTransform: 'uppercase' }}
										{...{
											onDelete: () => { }
										}}
									/>
								))
							}
							renderOption={(option, { selected }) => (
								<React.Fragment>
									<Checkbox checked={selected} />
									<ListItemText style={{ textTransform: 'uppercase' }} primary={option} />
								</React.Fragment>
							)}
							renderInput={(params) => (
								<TextField
									{...params}
									required
									variant="filled"
									fullWidth
									label="Best Fit Sizes"
								/>
							)}
						/>
					</div>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between',
							paddingTop: 8
						}}>
						<TextField
							select
							label="Age Category"
							required
							value={playgroupType.age_category}
							style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
							onChange={(e) => updateGroup('age_category', e.target.value)}
							variant="filled">
							{ages.map((s) => (
								<MenuItem value={s} style={{ textTransform: 'capitalize' }}>
									{s}
								</MenuItem>
							))}
						</TextField>
						<div style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'flex-start',
							width: '50%'
						}}>
							<FormControlLabel
								value="Counted Group Type?"
								control={<Checkbox checked={playgroupType.counted_group_type ? true : false} onChange={(e) => {
									updateGroup('counted_group_type', playgroupType.counted_group_type ? false : true)
								}} />}
								label="Counted Group Type?"
								labelPlacement="start"
								style={{
									height: 12
								}}
							/>
							<FormControlLabel
								value="Compatibility Group Type?"
								control={
									<Checkbox
										disabled={disableCompatToggle() ? true : false}
										checked={playgroupType.is_compatibility_group ? true : false}
										onChange={(e) => {
											console.log('changing')
											updateGroup('is_compatibility_group', playgroupType.is_compatibility_group ? false : true)
										}} />
								}
								label="Compatibility Group Type?"
								labelPlacement="start"
							/>
						</div>
					</div>
					{/*<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between',
							paddingTop: 8
						}}>
						<TextField
							label="Buffer Time"
							required
							type="number"
							value={playgroupType.buffer_time}
							style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
							onChange={(e) => updateGroup('buffer_time', e.target.value)}
							variant="filled"/>
					</div>*/}
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={save} color="secondary" disabled={isDisabled()}>
					SAVE
				</Button>
				<Button variant="outlined" onClick={() => setIsShown()} color="secondary">
					CANCEL
				</Button>
				{playgroupType?._id && (
					<Button
						variant="text"
						onClick={() => {
							setDelete('playgroup type')
						}}
						style={{
							fontFamily: 'Nunito',
							color: '#D02C2C',
							fontSize: '14px',
							lineHeight: '19px',
							marginLeft: 'auto',
							textTransform: 'uppercase',
							fontWeight: '800'
						}}>
						Delete Playgroup Type
					</Button>
				)}
			</DialogActions>
		</Dialog>
	)
}

export default PlaygroupTypeDialog
